import React from 'react';
import { Row, Col, Rate } from 'antd';
import ShadowBox from 'layouts/ShadowBox';
import css from './FiveStarReviewsBlock.module.scss';
import evgeniaImg from 'static/img/home/Evgenia.png';
import olivierImg from 'static/img/home/Olivier.png';
import damisiImg from 'static/img/home/Damisi.png';
import { useTranslation } from 'react-i18next';

export default function FiveStarReviewsBlock() {

  const { t } = useTranslation()

  const renderReview = (
    tutorName: string,
    subject: string,
    img: string,
    review: string,
    customerName: string
  ) => (
    <ShadowBox style={{ padding: '0.5em' }}>
      <Rate defaultValue={5} />
      <div className={css.reviewerInfo}>
        <img src={img} alt="Tutor" />
        <div className={css.tutorInfo}>
          <span>{tutorName}</span>
          <span>{subject} {t('Tutor')}</span>
        </div>
      </div>
      <div className="th-box-text">{review}</div>
      <i className="th-purple">{customerName}</i>
    </ShadowBox>
  );

  return (
    <Row
      type="flex"
      justify="center"
      align="middle"
      style={{
        backgroundColor: '#F9F9F9'
      }}
    >
      <Col lg={18} xs={22}>
        <div className="th-boxes">
          {renderReview(
            `${t('Evgenia M')}`,
            `${t('Chemistry')}`,
            evgeniaImg,
            `${t('Evgenia is an excellent tutor She’s very friendly, patient and made topics I struggled with easy to understand Highly recommend and look forward to more lessons with her')}`,
            `${t('Katya S, Parent')}`
          )}
          {renderReview(
            `${t('Olivier S')}`,
            `${t('Maths')}`,
            olivierImg,
            `${t('I feel that Ollie has hugely helped me out in my studies; he has helped me revise for my mocks and learn things I was not able to grasp in school Ollie keeps me interested in learning!')}`,
            `${t('Amelia H, Student')}`
          )}
          {renderReview(
            `${t('Damisi A')}`,
            `${t('English')}`,
            damisiImg,
            `${t('I definitely recommend Damisi to everybody! She knows how to handle her students; is very encouraging and attentive All in all; Damisi is a very helpful and caring young lady')}`,
            `${t('Ghidei B, Student')}`
          )}
        </div>
      </Col>
    </Row>
  );
}
